import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {PrlProfilesComponent} from './components/prl-profiles/prl-profiles.component';
import {prlAuthentificationGuard} from '../../shared/services/prl-authentification-guard';
import {PrlProfileAddComponent} from './components/prl-profile-add/prl-profile-add.component';
import {PrlProfileEditComponent} from './components/prl-profile-edit/prl-profile-edit.component';
import {PrlPageGuard} from '../../shared/services/prl-page.guard';

const routes: Routes = [
    {
        path: 'profiles',
        component: PrlProfilesComponent,
        canActivate: [prlAuthentificationGuard, PrlPageGuard],
        data: {pageName: 'Profiles Page'}
    },
    {
        path: 'profiles/create',
        component: PrlProfileAddComponent,
        canActivate: [prlAuthentificationGuard, PrlPageGuard],
        data: {
            className: 'com.playtech.mexos.contract.portal.CampaignProfilePrlObj',
            threeColumns: true,
            restLink: '/profiles',
            routeLink: '/profiles',
            pageName: 'Profiles Page'
        }
    },
    {
        path: 'profiles/:id',
        component: PrlProfileEditComponent,
        canActivate: [prlAuthentificationGuard, PrlPageGuard],
        data: {
            className: 'com.playtech.mexos.contract.portal.CampaignProfilePrlObj',
            threeColumns: true,
            restLink: '/profiles',
            routeLink: '/profiles',
            pageName: 'Profiles Page'
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PrlProfilesRoutingModule {
}
